import React, { useState, useEffect } from 'react'
import Spinner from '../../../components.js/elements/Spinner'
import SendPush from '../../../components.js/serveur/push/SendPush'
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'
import useForm from '../../../hooks/useForm'
import imagePush from '../../../images/imagepush.png'
import useFirebase from './../../../firebase/useFirebase'
import { format } from 'date-fns'
import fr from 'date-fns/locale/fr'
import SendHistoriquePush from '../../../components.js/serveur/push/SendHistoriquePush'
import usePush from '../../../hooks/usePush'
import ModalConfirmSendPush from '../../../components.js/serveur/push/ModalConfirmSendPush'
import ModalConfirmSendHistoryPush from '../../../components.js/serveur/push/ModalConfirmSendHistoryPush'

const INITIAL_STATE = {
    title:'',
    message:'',
}

const MessagePush = () => { 
    const [montage, setMontage] = useState(true)
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const { readDataTokens, readDataMessagesPush, messagesPush, tokens, writeData } = useFirebase()
    const { handleChange, values, refresh } = useForm(INITIAL_STATE)
    const { _sendPushNotification } = usePush()
    const [titleHistory, setTitleHistory] = useState()
    const [messageHistory, setMessageHistory] = useState()

    useEffect(() => {
        window.scrollTo(0, 0)
        setMontage(false)
    },[])

    useEffect(() => {
        readDataTokens(keyUid)
        readDataMessagesPush(keyUid)
    },[montage])

    if (montage) return <Spinner />

    // ExponentPushToken[I88p4GCSIKKuXlYNBP7sQE]

    const _handleSendCollectifMessage = () => {
        _saveMessage(values.title, values.message)
        tokens.map(token => _sendPushNotification(token.id,values.title, values.message))
        refresh()
    }

    const _saveMessage = (title, message) => {
        const date = format(new Date(Date.now()), 'EEEE dd MMMM yyyy', {locale:fr})
        const dateInt = Date.now()
        const data = {
            date:date,
            dateInt:dateInt,
            title:title,
            message:message
        }
        writeData('entreprises/'+keyUid+'/messagesPush',data)
    }

    const _sendHistoricMessage = () => {
        _saveMessage(titleHistory, messageHistory)
        tokens.map(token => _sendPushNotification(token.id, titleHistory, messageHistory))
    }

    return (
        <div className='container-fluid'>

            <HeaderReturn title='Message push' image={imagePush} link='/homeServeur'/> 

            <SendPush
                values={values} 
                handleChange={handleChange}
            />
            <SendHistoriquePush
                messagesPush={messagesPush}
                setTitleHistory={setTitleHistory}
                setMessageHistory={setMessageHistory}
            />

            {/* MODAL */}
            <ModalConfirmSendPush
                _handleSendCollectifMessage={_handleSendCollectifMessage}
            />
            <ModalConfirmSendHistoryPush
                _sendHistoricMessage={_sendHistoricMessage}
            />
        </div>
    )
}

export default MessagePush

